const message = "http module is not available in the browser build";

function notImplemented(fn) {
  return function notImplementedWrapper() {
    throw new Error(`${fn}: ${message}`);
  };
}

module.exports = {
  request: notImplemented("http.request"),
  get: notImplemented("http.get"),
  Agent: notImplemented("http.Agent"),
};
